import { ConferenceClient } from './ConferenceClient/ConferenceClient';
import { SupplierClient } from './SupplierClient/SupplierClient';

export class OtherClient {
  /**
   *
   * @param {import('./HTTPClient').HTTPClient} httpClient
   * @param {string} baseURL
   */
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = baseURL;

    this.conference = new ConferenceClient(httpClient, baseURL);
    this.supplier = new SupplierClient(httpClient, baseURL);
  }
}
